import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/layout/Navbar";
import Home from "./components/pages/Home";
import LaMesa from "./components/pages/LaMesa";
import AboutUs from "./components/pages/AboutUs";
import Contact from "./components/pages/Contact";
import Footer from "./components/pages/Footer";
import NotFound from "./components/pages/NotFound";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navbar />}>
            <Route index element={<Home />} />
            <Route path="LaMesa" element={<LaMesa />} />
            <Route path="AboutUs" element={<AboutUs />} />
            <Route path="Contact" element={<Contact />} />
            <Route path="404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
